export default __webpack_public_path__ + "1ffff5c70de2006f9c6bcc667541f637.png";